import { pageHead, unavailableHead, hasUnavailableMatch } from "@/lib/seoPolicy";
import { createFileRoute } from "@tanstack/react-router";
import DogFence from "@/pages/DogFence";

export const Route = createFileRoute("/_public/services/dog-fence")({
  head: ({ matches }) => hasUnavailableMatch(matches) ? unavailableHead() : pageHead("Dog Fence Installation | Modern Fence Install", "Professional non-electric dog fence installation \u2014 a real physical barrier with no buried wire and no shock collar. Get your fence price in minutes.", "/services/dog-fence", false),
  component: DogFence,
});
